function nobr(string) {
  return string.replace(/\s+/g, '\u00a0');
}

// eslint-disable-next-line import/prefer-default-export
export { nobr };
